import { useMediaQuery, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
  ButtonBoxStyled,
  CarouselBoxStyled,
  CarouselImageBoxStyled,
  ComplianceCardStyled,
  ImageBoxStyled,
  LowerButtonStyled,
  MainTextBoxStyled,
  TitleBoxStyled,
} from '../styles/ComplianceCard.styles';
import { Carousel, ComplianceCardProps } from '../types/ComplianceCard.types';

export const ComplianceCardNew = (props: ComplianceCardProps) => {
  const {
    bgColor,
    onClick,
    icon,
    title,
    mainText,
    carousel,
    linkText,
    center,
  } = props;

  const { breakpoints } = useTheme();
  const mediumPadBreakpoint = 1025;
  const isPad = useMediaQuery(breakpoints.between('sm', mediumPadBreakpoint));
  const isPhone = useMediaQuery(breakpoints.down('sm'));

  const getCarouselItemText = ({ text }: Carousel) => {
    if (isPhone) {
      return text.xs;
    } else if (isPad) {
      return text.sm;
    } else {
      return text.lg;
    }
  };

  return (
    <ComplianceCardStyled
      item
      backgroundColor={bgColor}
      center={center}
      hasLinkText={!!linkText}
    >
      <Grid container>
        <ImageBoxStyled item hideBlock={!icon}>
          <img src={icon} alt="" />
        </ImageBoxStyled>

        <TitleBoxStyled item hideBlock={!title}>
          <Typography variant={isPhone ? 'h2' : 'h3'}>{title}</Typography>
        </TitleBoxStyled>

        <MainTextBoxStyled
          item
          hideBlock={!(mainText && (!carousel || isPhone))}
        >
          <Typography variant={isPad ? 'h5' : 'h4'}>{mainText}</Typography>
        </MainTextBoxStyled>

        <ButtonBoxStyled item hideBlock={!linkText || !isPhone}>
          <Button onClick={onClick} variant='contained'>{linkText}</Button>
        </ButtonBoxStyled>

        <CarouselBoxStyled item hideBlock={false}>
          <Grid container>
            {carousel &&
              carousel.map((item: Carousel, index: number) => (
                <CarouselImageBoxStyled item key={`${index}`} id={`${index}`}>
                  <div>
                    <img src={item.img} alt={getCarouselItemText(item)} />
                    <div>
                      {getCarouselItemText(item)
                        .split('<br>')
                        .map((elt) => (
                          <div key={elt}>{elt}</div>
                        ))}
                    </div>
                  </div>
                </CarouselImageBoxStyled>
              ))}
          </Grid>
          <LowerButtonStyled role='link' onClick={onClick} variant='contained' hideBlock={isPhone || !linkText}>
            {linkText}
          </LowerButtonStyled>
        </CarouselBoxStyled>
      </Grid>
    </ComplianceCardStyled>
  );
};
